
    import "src/shared/components/CustomTablePagination/index.module.scss?farm_css_modules";
    
    export default {"editButton": `editButton-3f81edba`,"main": `main-3f81edba`,"pagination": `pagination-3f81edba`,"table": `table-3f81edba`}
    